
import {defineComponent} from "vue";

export default defineComponent({
    name: "DevicePrice",
    filters: {
        replacePointByComma(price: string) {
            return price.toString().replace('.', ',');
        },
        centsHandler(price: string) {
            const wholePart = price.split(',')[0];
            const cents = price.split(',')[1];
            if (typeof cents !== 'undefined') {
                // Si les centimes sont à '0' ou '00', on ne les affiche pas
                if (cents === '0' || cents === '00') {
                    return wholePart;
                    // Si seulement les dixièmes sont présents sans des centièmes, on ajoute un 0 (cas d'un float renvoyé par le back).
                } else if (cents.length === 1) {
                    return price.concat('0');
                } else {
                    return price;
                }
            } else {
                return price;
            }
        }
    },
    props: {
        // plusieurs prix selon le forfait
        multiplePrice: {
            type: Boolean,
            required: false,
            default: false
        },
        compactPrice: {
            type: Boolean,
            required: false,
            default: false
        },
        isMini: {
            type: Boolean,
            required: false,
            default: false
        },
        customPrice: {
            type: Boolean,
            required: false,
            default: false
        },
        // prix total avec promo
        totalPriceWithPromo: {
            type: Number,
            default: 0
        },
        // prix total sans promo (prix barré)
        totalPriceWithoutPromo: {
            type: Number,
            default: null
        },
        // montant de la mensualité
        monthlyAmountInCents: {
            type: Number,
            default: null
        },
        // durée du paiement mensuel
        monthlyDuration: {
            type: Number,
            default: null
        },
        // Libellé affiché quand le montant mensuel est non renseigné
        genericLabel: {
            type: String,
            default: null
        },
        // Libellé affiché quand le taux de prêt est à 0%
        loanRateZeroLabel: {
            type: String,
            required: false,
            default: null
        },
        isCentsFormat: {
            type: Boolean,
            default: false
        },
        isPriceInversionEnabled: {
            type: Boolean,
            required: true
        }
    },
    computed: {
        formattedTotalPriceWithPromo() {
            return this.formattedPrice(this.totalPriceWithPromo);
        },
        formattedTotalPriceWithoutPromo() {
            return this.formattedPrice(this.totalPriceWithoutPromo);
        },
        formattedPriceWithPromo() {
            return this.formattedTotalPriceWithPromo;
        },
        formattedPriceWithoutPromo() {
            return this.formattedTotalPriceWithoutPromo;
        },
        formattedMonthlyPrice() {
            return this.formattedPrice(this.monthlyAmountInCents);
        },
        // prix vocalisé lorsqu'on combine le prix avec d'autres informations
        priceAccessibility() {
            let pricePrefix = this.formattedPriceWithPromo + ' euros';
            if (this.formattedPriceWithoutPromo !== undefined) {
                pricePrefix += ' au lieu de ' + this.formattedPriceWithoutPromo + ' euros';
            }
            return pricePrefix;
        },
        paymentInfoLabel() {
            if (this.monthlyAmountInCents) {
                let monthlyPaymentAmount = this.formattedPrice(this.monthlyAmountInCents);
                let formattedMonthlyPaymentAmount = this.$options.filters.replacePointByComma(monthlyPaymentAmount);
                return "ou&nbsp;" + this.monthlyDuration + "&nbsp;x&nbsp;" + formattedMonthlyPaymentAmount + "&#8239;€";
            } else if (this.genericLabel) {
                return this.genericLabel;
            } else {
                return null;
            }
        },
        complementaryClass() {
            return {
                'ob1-price-compact': this.compactPrice,
                'ob1-price-mini': this.isMini
            }
        }
    },
    methods: {
        // prix formaté en fonction de la prop "isCentsFormat"
        // - si false, pas de transformation, on a déjà un prix au format "XX,XX €"
        // - si true, la valeur passée à la prop "price" est en centimes, on divise donc par 100 pour avoir la valeur au format "XX,XX €"
        formattedPrice(price?: number) {
            if (!price) {
                return undefined
            }
            if (this.isCentsFormat) {
                return (price / 100).toString()
            } else {
                return price
            }
        }
    }
});
